require('./redactionProperties.less');

var Marionette = require('marionette'),
    FillView = require('./fillSelector/view'),
    ReasonCodeSelectorView = require('./reasonCodeSelector/view'),
    $ = require('jquery'),
    _ = require('underscore'),
    fvChannel = require('glRadio').channel('FV');


// DVBC-1796: hide from UI but leave rest of functionality intact in case someone wants this back.
var SHOW_COMMENTS = 0;


var instVars = {
    selectedCodes: null,
    shapeModel: null,
    availableReasonCodes: null, //cache the collection now that we have a search-as-you-type filter
    renderDisabled: false
};


module.exports = Marionette.LayoutView.extend({

    className: 'redactionProps',

    SHOW_FILL_VIEW: 1,

    template: require('./redactionProperties.hbs'),

    regions: {
        fillRegion:         '.redact-zone-dialog-fill-region',
        reasonCodeRegion:   '.rd-reason-code-region'
    },

    initialize: function(options) {

        _.extend( this, instVars, _.pick( options, 'shapeModel', 'renderDisabled' ) );

        // Want a reference to the selectedCodes from the model from listening here
        this.selectedCodes = this.shapeModel.getReasonCodeCollection();
        this.availableReasonCodes = this.shapeModel.getAvailableCodesToSelectInZoneDialog();

        this.listenTo( this.selectedCodes, 'add remove', this._codeSelectionCB );

        /* just normalize Backbone's callback parameters from a reset to add/remove*/
        this.listenTo( this.selectedCodes, 'reset',  _.bind( function( collection, options ) {
            this._codeSelectionCB( null, collection, options );
        }, this ));


        /* Hack instead of 'subclassing' the find and redact classes for now -- override these fn's when provided  */
        if ( options.onReasonCodeSubViewChange ) {
            this.onReasonCodeSubViewChange = options.onReasonCodeSubViewChange;
        }

        if (options.selectAllReasonCodes) {
            this.selectAllReasonCodes = options.selectAllReasonCodes;
        }

        if ( options.clearAllReasonCodes ) {
            this.clearAllReasonCodes = options.clearAllReasonCodes;
        }

    },
    serializeData: function() {

        return {
            comment: this.shapeModel.get('comments') ? this.shapeModel.get('comments') : '',
            hideComments: !SHOW_COMMENTS
        };

    },

    ui: {
        commentsTextArea:   '.rd-comments',
        numberSelected:     '.r-count',
        selectAllRcButton:  '.rd-select-all-rc',
        clearAllRcButton:   '.rd-clear-all-rc'
    },

    onRender: function() {

        if ( this.SHOW_FILL_VIEW ) {
          this.showFillView();
        }

        this.showReasonCodeView();

        this._updateSelectAllStateAndNumberSelectedCodes();

        if ( this.renderDisabled ) {
            this.ui.commentsTextArea.attr( 'disabled', 'disabled' );
            this.disableReasonCodesInteraction(); //  a bit superfluous since the subview can be rendered disabled
        }

    },

    showFillView: function() {

        this.fillRegion.show( new FillView({
            renderDisabled: this.renderDisabled,
            originalFill: this.shapeModel.get('fill'),
            onChange: _.bind( function( fill ) {
                this.shapeModel.set( { fill: fill });
            }, this )
        }));

    },

    showReasonCodeView: function() {

        this.reasonCodeRegion.show( new ReasonCodeSelectorView({
            renderDisabled: this.renderDisabled,
            availableCodes: this.availableReasonCodes,
            selectedCodes: this.selectedCodes,
            onChange: _.bind( function( selectedReasonCodes ) {
                this.onReasonCodeSubViewChange( selectedReasonCodes ) ;
            }, this)
        }));

    },

    /* This can be ovewritten by an option */
    onReasonCodeSubViewChange: function( selectedReasonCodes ) {
        this.selectedCodes.set( selectedReasonCodes );
    },

    events: {
        'input @ui.commentsTextArea':       'commentChange',
        'click @ui.selectAllRcButton':      'selectAllReasonCodes',
        'click @ui.clearAllRcButton':       'clearAllReasonCodes'
    },

    selectAllReasonCodes: function() {
        this.selectedCodes.reset( this._getReasonCodeModelsForSelectAll(), { sourceNotFromChosen: true } );
    },

    /**
     * Ideally would like an alphanumeric sort to match the order seen in code letter views and code boxes.
     * But sorting these as a ShapeReasonCode collection won't help, eg ( new ShapeReasonCodeCollection( this.availableReasonCodes.models ).models ),
     * reset is called on the selected codes, which has the correct comparator.
     * Issue is with Chosen.js.
     * There is a plugin that is no longer supported by Chosen.js to try -- but it's not available on NPM --
     * -- would need to store in source/create separate NPM repo from its git repository.
     * We shouldn't change the order they are added by the user, but if the plugin supported, we could allievate somewhat here and on render.
     */
    _getReasonCodeModelsForSelectAll: function() {
        return this.availableReasonCodes.models;

    },

    clearAllReasonCodes: function() {
        this.selectedCodes.reset( null, { sourceNotFromChosen: true } );
    },

    _codeSelectionCB: function( codeModel, selectedCodes, options ) {

        this._updateSelectAllStateAndNumberSelectedCodes();

        if ( options && options.sourceNotFromChosen ) {
            this.reasonCodeRegion.currentView.setUiValueFromSelectedCodes();
        }

    },

    // Called onRender and SelectedCodeUpdate -- not a different subview now.
    _updateSelectAllStateAndNumberSelectedCodes: function() {

        var nSelectedCodes = this.selectedCodes.length;

        this.ui.numberSelected.html('(' + nSelectedCodes + ')');

        this._setDisabledSelectAllButtons( false );

        if ( nSelectedCodes ===  this._getReasonCodeModelsForSelectAll().length ) {
            this._disableSelectAllBtn( true );
        }

        if ( nSelectedCodes < 1 ) {
            this._disableClearAllBtn( true );
        }

    },

    commentChange: function(e) {
        this.shapeModel.set({ comments: $(e.target).val() });
    },

    enableReasonCodesInteraction: function() {

        this._setDisabledSelectAllButtons( false );
        this.reasonCodeRegion.currentView.enable();

    },

    disableReasonCodesInteraction: function() {

        this._setDisabledSelectAllButtons( true );
        this.reasonCodeRegion.currentView.disable();
    },

    _setDisabledSelectAllButtons: function( disabled ) {

        this._disableSelectAllBtn( disabled );
        this._disableClearAllBtn( disabled );
        this.ui.clearAllRcButton[0].disabled = disabled;

    },

    _disableSelectAllBtn: function( disable ) {
        this.ui.selectAllRcButton[0].disabled = disable;
    },

    _disableClearAllBtn: function( disable ) {
        this.ui.clearAllRcButton[0].disabled = disable;
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/redaction/dialog/redactionProperties.js
 ** module id = 236
 ** module chunks = 0
 **/